module.exports = __webpack_public_path__ + "img/全国征兵网.53975c9b.jpg";